import * as IoC from 'typescript-ioc';
import { MessageDescriptor } from 'react-intl';
import { AccountAdminSettingEntity } from '../common/account-admin-setting.entity';
import { BaseAccountAdminSettingViewModel } from '../common/base-account-admin-setting-form.viewmodel';
import { AI_AGENT_ACCESS_UPDATED_TEXT } from '../account-admin.text';
import TrackingServiceProvider from '../../../tracking-service/tracking-service-provider';
import { convertBoolTypeForMixPanel, TRACKING_EVENTS } from '../../../tracking-service/tracking-values';

class AIAgentAccessFormVM extends BaseAccountAdminSettingViewModel {
    constructor(
        protected readonly entity: AccountAdminSettingEntity,
        private readonly accountName: string = '',
        @IoC.Inject private readonly trackingService: TrackingServiceProvider = IoC.Container.get(TrackingServiceProvider),
    ) {
        super(entity);
    }

    public get notificationMessage(): MessageDescriptor {
        return AI_AGENT_ACCESS_UPDATED_TEXT;
    }

    public async apiCall(): Promise<void> {
        await this.accountAdminDAO.updateAIAgentAccessData({
            ...this.entity.getCommonAPIPayload(),
            aiAgentAccessEnabled: this.entity.enabled,
        });

        this.trackConfigureAIAgentAccessMixPanel();
    }

    private trackConfigureAIAgentAccessMixPanel = (): void => {
        this.trackingService.get().track(TRACKING_EVENTS.CONFIGURE_AI_AGENT_ACCESS, {
            'Account ID': String(this.entity.accountId),
            'Account Name': this.accountName ?? '',
            Enabled: convertBoolTypeForMixPanel(this.entity.enabled),
        });
    };
}

export { AIAgentAccessFormVM };
